import { render, staticRenderFns } from "./PopupUpdateStaff.vue?vue&type=template&id=34daeeb8"
import script from "./PopupUpdateStaff.vue?vue&type=script&lang=js"
export * from "./PopupUpdateStaff.vue?vue&type=script&lang=js"
import style0 from "./PopupUpdateStaff.vue?vue&type=style&index=0&id=34daeeb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports